// src/components/SpeakButton.jsx
// Lautsprecher-Knopf, der einen Text in der angegebenen Sprache vorliest.
// Zeigt nichts an, wenn der Browser keine Sprachausgabe kann.
import React from "react";
import { isSpeechSupported, speak } from "../utils/speech";

export default function SpeakButton({ text, lang, label = "Satz anhören", small = false }) {
  if (!isSpeechSupported()) return null;
  return (
    <button
      type="button"
      className={`speak-button${small ? " speak-button--small" : ""}`}
      aria-label={label}
      title={label}
      onClick={() => speak(text, lang)}
    >
      <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
        <path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor" />
        <path
          d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
